<template>
    <!--div>
        <router-link to="/dn/v2">Wareneingang</router-link>

        <router-link v-for="vendor in vendors" v-bind:key="vendor.id" :to="'/dn/v2/vendor/' + vendor.id">{{ vendor.name }}</router-link><br>
    </div-->
    <!-- Grid -->
    <div class="container-fluid">
        <div class="row">
            <div class="col-8 offset-2">

                <!--Breadcrumb-->
                <nav style="--bs-breadcrumb-divider: '>';  font-size: 35px;" aria-label="breadcrumb">
                    <ol class="breadcrumb py-0 pt-3 container bg-light">
                        
                        <li class="breadcrumb-item pl-2 pr-2"><a aria-current="page">Wareneingang</a></li>
                      
                    </ol>
                </nav>

            </div>

        </div>
        <div class="row">
            <div class="col-2">

               
            </div>

             <!-- Wareneingang Seite1 Lieferanten-->

            <div class="col-8">
                <div class="card">
                    <div class="list-group">
                        <router-link :to="'/dn/v2/vendor/-1'" class="list-group-item list-group-item-action py-0">Alle Händler</router-link>
                        <router-link v-for="vendor in vendors" v-bind:key="vendor.id" :to="'/dn/v2/vendor/' + vendor.id"  class="list-group-item list-group-item-action py-0">{{ vendor.name }}</router-link>
                    </div>
                </div>
            </div>
            <div class="col-2">
               
            </div>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            vendors: [],
        }
    },
    created() {
        axios.get('/vendor/all').then( vendorResponse => {
            this.vendors = vendorResponse.data.filter( elem => elem.deliveryNoteActive );
        } )
    }
}
</script>